import { TimelineUpdatesEventCentre } from './timelineUpdates.eventCentre';
import { useSignalRService } from '../useSignalRService.hook';
import { useEffect, useMemo } from 'react';
import {
  TimelineUpdatesSubscriptionStream,
  TimelineUpdatesSubscriptionMatcher,
  TimelineUpdatesSubscriptionCallback
} from './timelineUpdates.types';

export function useTimelineUpdatesEventCentre({
  callback,
  matcher,
  stream
}: {
  callback: TimelineUpdatesSubscriptionCallback;
  matcher: TimelineUpdatesSubscriptionMatcher;
  stream: TimelineUpdatesSubscriptionStream;
}) {
  const signalR = useSignalRService();
  const timelineUpdates = TimelineUpdatesEventCentre.getInstance(signalR);

  const subscription = useMemo(() => timelineUpdates.subscribe(), [timelineUpdates]);

  useEffect(() => {
    subscription.setCallback(callback);
  }, [callback, subscription]);

  useEffect(() => {
    subscription.setMatcher(matcher);
  }, [matcher, subscription]);

  useEffect(() => {
    if (stream.deliveryIDs.length === 0 && stream.workflowIDs.length === 0 && stream.projectIDs.length === 0) {
      return;
    }
    subscription.stream(stream);
  }, [stream, subscription]);

  useEffect(() => {
    return () => subscription.unsubscribe();
  }, [subscription]);

  return subscription;
}
